/* eslint-disable react/prop-types */
import * as pageStyles from '../styles/internal-page/internal-page.module.scss';
import React from 'react';
import { getFetchingInterval, getParams } from '../utils/fluxWidgets';
import {
  getInternalPageCarrousel,
  getInternalPageCover,
  getInternalPageVideoHeader,
  mapSectionIntoMain,
  getSEOInformations,
} from '../utils/parsing';
import {
  getLastYoutubeVideosByParameters,
  getTweetsByParameters,
} from '../services/api';
import '../services/i18n';

import Content from '../components/page_structure/Content';
import ContentTop from '../components/page_structure/ContentTop';
import Seo from '../seo/seo';
import Title from '../components/shared/Title';
import { graphql, Slice } from 'gatsby';
import { useTranslation, getI18n } from 'react-i18next';
import TitleFormation from '../components/shared/TitleFormation';
import InternalPageSimpleLayoutNew from '../components/layout/templates/InternalPageSimpleLayoutNew';
import InternalPageHomeLayoutNew from '../components/layout/templates/InternalPageHomeLayoutNew';
import { setupi18n } from '../utils/utils';

export const Head = ({ data, pageContext, location }) => {
  const internalPage = data.page;
  const {header, publishedAt, id} = internalPage;

  const {locale, generalSeo, websiteSeo, name } = pageContext;
  const {
    canonical_link,
    pageSeo,
    metaDescription,
  } = getSEOInformations(data);
  const headerCover = getInternalPageCover(header);

  return (
    <Seo
      canonicalLink={canonical_link}
      coverMedia={headerCover}
      generalSeo={generalSeo}
      id={id}
      language={locale}
      location={location}
      metaDescription={metaDescription}
      pageSeo={pageSeo}
      publishedAt={publishedAt}
      type={pageContext.pageType}
      website={name}
      websiteSeo={websiteSeo}
    />
  );
};

// const showPublicationDate = false;

export default function InternalPage ({ data, pageContext }) {
  const internalPage = data.page;
  const {
    header,
    content,
    bottom,
    related_column_name,
    related_contents,
    // publishedAt, // disponible mais pas utilisé
  } = internalPage;
  const { isHomePage, websiteRoot, breadcrumbs, locale} = pageContext;
  setupi18n(locale, getI18n());
  const headerCover = getInternalPageCover(header);
  const headerCarrousel = getInternalPageCarrousel(header);
  const headerVideo = getInternalPageVideoHeader(header);
  const [tweets, setTweets] = React.useState([]);
  const [youtubeVideos, setYoutubeVideos] = React.useState([]);
  const [tweetsBottom, setTweetsBottom] = React.useState([]);
  const [youtubeVideosBottom, setYoutubeVideosBottom] = React.useState([]);
  const newContent = mapSectionIntoMain(content);
  const newContentBottom = mapSectionIntoMain(bottom);
  const { t } = useTranslation();

  React.useEffect(() => {
    const abortController = new AbortController();
    const twitterParameters = [];
    const youtubeParameters = [];
    const twitterBottomParameters = [];
    const youtubeBottomParameters = [];

    getParams(newContent, youtubeParameters, twitterParameters);
    getParams(
      newContentBottom,
      youtubeBottomParameters,
      twitterBottomParameters
    );

    const intervalTwitter = getFetchingInterval(
      twitterParameters,
      setTweets,
      getTweetsByParameters
    );
    const intervalYoutube = getFetchingInterval(
      youtubeParameters,
      setYoutubeVideos,
      getLastYoutubeVideosByParameters
    );
    const intervalTwitterBottom = getFetchingInterval(
      twitterBottomParameters,
      setTweetsBottom,
      getTweetsByParameters
    );
    const intervalYoutubeBottom = getFetchingInterval(
      youtubeBottomParameters,
      setYoutubeVideosBottom,
      getLastYoutubeVideosByParameters
    );

    return () => {
      clearInterval(intervalTwitter);
      clearInterval(intervalYoutube);
      clearInterval(intervalTwitterBottom);
      clearInterval(intervalYoutubeBottom);
      abortController.abort();
    };
  }, [newContent, newContentBottom]);

  const LayoutComponent = isHomePage ?
    InternalPageHomeLayoutNew : InternalPageSimpleLayoutNew;
  return (
    <Slice alias={'internal-page-layout'}>
      <LayoutComponent
        bottomContent={
          newContentBottom?.map((contentEl, index) => {
            return (
              <Content
                elem={contentEl}
                fullWidth
                key={index}
                locale={locale}
                siteURL={websiteRoot}
                tweets={tweetsBottom[index]?.messages}
                youtubeVideos={youtubeVideosBottom[index]}
              />
            );
          })
        }
        filAriane={breadcrumbs}
        header={
          <ContentTop
            carrousel={headerCarrousel}
            className={pageStyles.marginBetweenBlocs}
            cover={headerCover}
            headerVideo={headerVideo}
            locale={locale}
            siteURL={websiteRoot}
          />
        }
        related_column_name={related_column_name}
        related_contents={related_contents}
        url={websiteRoot}
      >
        {!isHomePage
        && internalPage?.title
        && internalPage?.header[0]?.__typename !== 'CmsPortalComponentHeaderFormationHeader'
        && (
          <div style={{ marginBottom: 20 }}>
            <Title
              label={internalPage.title}
              separator
              subtitle={internalPage.heading}
            />
          </div>
        )}
        {!isHomePage
        && internalPage?.title
        && internalPage?.header[0]?.__typename === 'CmsPortalComponentHeaderFormationHeader'
        && (
          <TitleFormation
            contents={internalPage.header[0].content_action}
            label={internalPage.title}
            subtitle={internalPage.heading}
          />
        )}
        {isHomePage && (
          <h1 className={pageStyles.hiddenTitle}>
            {t('internal.page.welcome')}
          </h1>
        )}
        {newContent?.map((content, index) => {
          return (
            <Content
              elem={content}
              fullWidth={related_contents?.length > 0 ? false : true}
              key={index}
              locale={locale}
              siteURL={websiteRoot}
              tweets={tweets[index]?.messages}
              youtubeVideos={youtubeVideos[index]}
            />
          );
        })}
      </LayoutComponent>
    </Slice>
  );
}

export const query = graphql`
  query ($pageId: String!, $websiteId: String!) {
    page: cmsPortalInternalPage(
      id: { eq: $pageId }
      websites: { elemMatch: { id: { eq: $websiteId } } }
    ) {
      ...InternalPageData
      content {
        ...InternalPageContent
      }
      related_contents {
        ...RelatedContentsFragment
      }
      bottom {
        ...InternalPageContent
      }
    }
    # website: cmsPortalWebsite(id: { eq: $websiteId }) {
    # ...WebsiteFragment
    # }
    # frGeneralSettings: cmsPortalGeneralSettings(locale: { eq: "fr" }) {
    # ...GeneralSettingsFragment
    # }
    # enGeneralSettings: cmsPortalGeneralSettings(locale: { eq: "en" }) {
    # ...GeneralSettingsFragment
    # }
  }
`;
